module.exports = __webpack_public_path__ + "static/img/197.c5f6c58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/rjzz/197.jpg
// module id = +IPr
// module chunks = 0